/**
 * 
 */
class BlockSearch {

	/**
	 * 
	 * @type String
	 */
	action = '';

	/**
	 * 
	 * @type String
	 */
	ajaxUrl = '';

	/**
	 * 
	 * @type Boolean
	 */
	closeOnClickOutside = true;

	/**
	 * 
	 * @type String
	 */
	closeSelector = '.block-search-close';

	/**
	 * 
	 * @type HTMLElement
	 */
	element = null;

	/**
	 * 
	 * @type HTMLFormElement
	 */
	formElement = null;

	/**
	 * 
	 * @type String
	 */
	formSelector = 'form.block-search-form';

	/**
	 * 
	 * @type HTMLInputElement
	 */
	inputElement = null;

	/**
	 * 
	 * @type String
	 */
	inputSelector = 'input[type="search"]';

	/**
	 * 
	 * @type Number
	 */
	inputTimeoutDelay = 100;

	/**
	 * 
	 * @type Number
	 */
	inputTimeoutId = null;

	/**
	 * 
	 * @type Boolean
	 */
	isOpen = false;

	/**
	 * 
	 * @type String
	 */
	lastSearchTerm = undefined;

	/**
	 * 
	 * @type String
	 */
	nonce = '';

	/**
	 * 
	 * @type Boolean
	 */
	overlayScrollCustomBehavior = false;

	/**
	 * 
	 * @type HTMLElement
	 */
	overlayScrollElement = null;

	/**
	 * 
	 * @type Boolean
	 */
	overlayScrollEnabled = false;

	/**
	 * 
	 * @type Number
	 */
	overlayScrollLastHeight = 0;

	/**
	 * 
	 * @type String
	 */
	overlayScrollSelector = '.block-search-results-wrapper';

	/**
	 * 
	 * @type Number
	 */
	overlayScrollSetupTimeoutId = null;

	/**
	 * 
	 * @type Number
	 */
	overlayWindowScrollY = null;

	/**
	 * 
	 * @type Object
	 */
	requestArgs = undefined;

	/**
	 * 
	 * @type HTMLElement
	 */
	resultElement = null;

	/**
	 * 
	 * @type String
	 */
	resultSelector = '.block-search-results';

	/**
	 * 
	 * @type HTMLElement
	 */
	scrollDummyElement = null;

	/**
	 * 
	 * @type String
	 */
	scrollDummyClassName = 'wmu-search-scroll-dummy';

	/**
	 * 
	 * @type String
	 */
	searchLinkSelector = 'a[href^="search:"]';

	/**
	 * 
	 * @type Boolean
	 */
	searchOnFocus = false;

	/**
	 * 
	 * @type String
	 */
	searchOnFocusTerm = '';

	/**
	 * 
	 * @type String
	 */
	toggleSelector = '.block-search-open-toggle';

	/**
	 * 
	 * @type XMLHttpRequest
	 */
	xhr = null;

	/**
	 * 
	 * @param {HTMLElement} element 
	 * @param {Object} args 
	 */
	constructor( element, args = {} )
	{
		this.action = args.action;
		this.ajaxUrl = args.ajaxUrl;
		this.element = element;
		this.nonce = args.nonce;
		this.searchOnFocus = (
			args.searchOnFocus == "1"
			|| args.searchOnFocus == "true"
			|| args.searchOnFocus == true
			|| args.searchOnFocus == 1
			) ? true : false;
		this.searchOnFocusTerm = args.searchOnFocusTerm || '';
		this.requestArgs = args.requestArgs || {};
		this.overlayScrollCustomBehavior = (
			args.overlayScrollCustomBehavior == "1"
			|| args.overlayScrollCustomBehavior == "true"
			|| args.overlayScrollCustomBehavior == true
			|| args.overlayScrollCustomBehavior == 1
			) ? true : false;
		
		if ( args.overlayScrollSelector )
		{
			this.overlayScrollSelector = args.overlayScrollSelector;
		}

		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onClickOutside = this.onClickOutside.bind( this );
		this.onCloseClick = this.onCloseClick.bind( this );
		this.onInput = this.onInput.bind( this );
		this.onInputTimeout = this.onInputTimeout.bind( this );
		this.onFocusIn = this.onFocusIn.bind( this );
		this.onFocusOut = this.onFocusOut.bind( this );
		this.onSearchLinkClick = this.onSearchLinkClick.bind( this );
		this.onToggleClick = this.onToggleClick.bind( this );
		this.overlayScrollSetupTimeout = this.overlayScrollSetupTimeout.bind( this );
		this.onWindowScroll = this.onWindowScroll.bind( this );
		this.onXhrAbort = this.onXhrAbort.bind( this );
		this.onXhrError = this.onXhrError.bind( this );
		this.onXhrLoad = this.onXhrLoad.bind( this );
	}

	/**
	 * 
	 */
	setup()
	{
		if ( ! this.element )
		{
			console.warn( 'Block search: missing block element' );
		}
		
		this.inputElement = this.element.querySelector( this.inputSelector );

		if ( ! this.inputElement )
		{
			console.warn( 'Block search: missing input element' );
		}

		this.inputElement.addEventListener( 'input', this.onInput );
		this.inputElement.addEventListener( 'focusin', this.onFocusIn );
		this.inputElement.addEventListener( 'focusout', this.onFocusOut );

		this.resultElement = this.element.querySelector( this.resultSelector );

		if ( ! this.resultElement )
		{
			console.warn( 'Block search: missing results element' );
		}

		this.formElement = this.element.querySelector( this.formSelector );

		if ( this.formElement )
		{
			this.formElement.addEventListener( 'submit', ( event ) => event.preventDefault() );
		}

		this.overlayScrollElement = this.element.querySelector( this.overlayScrollSelector );

		if ( ! this.overlayScrollElement )
		{
			console.warn( 'Block search: missing overlay element' );
		}

		this.element.wmuBlockSearch = this;

		this.setupClose( this.element );
		this.setupToggle( this.element );
		this.setupSearchLinks( this.element );
	}

	/**
	 * 
	 */
	clear()
	{
		if ( this.element )
		{
			this.element.wmuBlockSearch = undefined;
		}

		if ( this.inputElement )
		{
			this.inputElement.removeEventListener( 'input', this.onInput );
			this.inputElement.removeEventListener( 'focusin', this.onFocusIn );
			this.inputElement.removeEventListener( 'focusout', this.onFocusOut );
		}

		if ( this.formElement )
		{
			this.formElement.removeEventListener( 'submit', ( event ) => event.preventDefault() );
		}

		this.close();
		this.clearClose();
		this.clearToggle();
		this.clearSearchLinks();
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	clearClose( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.element;
		}

		contextElement.querySelectorAll( this.closeSelector ).forEach( ( closeElement ) =>
		{
			if ( closeElement.wmuBlockSearch )
			{
				closeElement.removeEventListener( 'click', this.onCloseClick );
				closeElement.wmuBlockSearch = undefined;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	setupClose( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.element;
		}

		contextElement.querySelectorAll( this.closeSelector ).forEach( ( closeElement ) =>
		{
			if ( ! closeElement.wmuBlockSearch )
			{
				closeElement.addEventListener( 'click', this.onCloseClick );
				closeElement.wmuBlockSearch = this;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	clearToggle( contextElement = null)
	{
		if ( null === contextElement )
		{
			contextElement = this.element;
		}

		contextElement.querySelectorAll( this.toggleSelector ).forEach( ( toggleElement ) =>
		{
			if ( toggleElement.wmuBlockSearch )
			{
				toggleElement.removeEventListener( 'click', this.onToggleClick );
				toggleElement.wmuBlockSearch = undefined;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	setupToggle( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.element;
		}

		contextElement.querySelectorAll( this.toggleSelector ).forEach( ( toggleElement ) =>
		{
			if ( ! toggleElement.wmuBlockSearch )
			{
				toggleElement.addEventListener( 'click', this.onToggleClick );
				toggleElement.wmuBlockSearch = this;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	clearSearchLinks( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.element;
		}

		contextElement.querySelectorAll( this.searchLinkSelector ).forEach( ( searchLinkElement ) =>
		{
			if ( searchLinkElement.wmuBlockSearch )
			{
				searchLinkElement.removeEventListener( 'click', this.onSearchLinkClick );
				searchLinkElement.wmuBlockSearch = undefined;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	setupSearchLinks( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.element;
		}

		contextElement.querySelectorAll( this.searchLinkSelector ).forEach( ( searchLinkElement ) =>
		{
			if ( ! searchLinkElement.wmuBlockSearch )
			{
				searchLinkElement.addEventListener( 'click', this.onSearchLinkClick );
				searchLinkElement.wmuBlockSearch = this;
			}
		} );
	}

	/**
	 * 
	 * @param {String} content 
	 */
	renderResults( content )
	{
		this.resultElement.innerHTML = content;

		/**
		 * On active les éventuels éléments spécifiques du block search qui pourraient être présent dans les résultats
		 */
		this.setupClose( this.resultElement );
		this.setupToggle( this.resultElement );
		this.setupSearchLinks( this.resultElement );

		/**
		 * On dispatch wmu/newElements pour conserver la logique générique de traitement post nouveau contenu
		 */
		window.dispatchEvent( new CustomEvent( 'wmu/newElements', {
			detail: {
				elements: [ this.resultElement ]
			}
		} ) );

		/**
		 * Mettre un surveillant sur les liens internes pour dispatch une action dessus
		 */
		this.resultElement.querySelectorAll( 'a' ).forEach( ( element ) =>
		{
			element.addEventListener( 'click', ( event ) =>
			{
				window.dispatchEvent( new CustomEvent( 'wmuwpblocks/search/clickOnResultItem', {
					detail: {
						block: this,
						href: element.href,
						originalEvent: event,
						searchTerm: this.lastSearchTerm,
						targetElement: element,
					}
				} ) );
			} );
		} );

		if ( content )
		{
			this.open();
		}

		/**
		 * On met à jour le système overlayScroll
		 */
		this.overlayScrollSetup();

		/**
		 * Dispatch spécifique au block search
		 */
		window.dispatchEvent( new CustomEvent( 'wmuwpblocks/search/renderResults', {
			detail: {
				block: this,
				content: content,
				searchTerm: this.lastSearchTerm,
			}
		} ) );
	}

	/**
	 * 
	 */
	searchAbort()
	{
		if ( null !== this.xhr )
		{
			this.xhr.abort();
			this.xhr = null;
		}
	}

	/**
	 * 
	 */
	searchComplete()
	{
		this.xhr = null;
		this.element.classList.remove( 'search-in-progress' );
	}

	/**
	 * 
	 */
	searchError( response )
	{
		console.warn( 'Search error', response );
	}

	/**
	 * 
	 * @param {Object} data
	 */
	searchSuccess( data )
	{
		console.log( 'Search success', data );

		if ( data.render )
		{
			this.renderResults( data.render );
			this.element.setAttribute( 'data-search-term', this.lastSearchTerm );
			this.element.setAttribute( 'data-result-count', parseInt( data.resultCount ) );
		}

		window.dispatchEvent( new CustomEvent( 'wmuwpblocks/search/success', {
			detail: {
				block: this,
				results: data,
				searchTerm: this.lastSearchTerm,
			}
		} ) );
	}

	/**
	 * 
	 * @param {String} searchTerm
	 */
	searchStart( searchTerm = undefined )
	{
		if ( undefined === searchTerm )
		{
			searchTerm = this.inputElement.value;
		}
		else if ( searchTerm !== this.inputElement.value )
		{
			this.inputElement.value = searchTerm;
			this.inputElement.dispatchEvent( new CustomEvent( 'change' ) );
		}

		if ( searchTerm === this.lastSearchTerm )
		{
			this.open();
			return;
		}

		if ( null != this.xhr )
		{
			this.searchAbort();
		}

		console.log( `block search start: ${searchTerm}` );

		this.xhr = new XMLHttpRequest();
		this.xhr.addEventListener( 'load', this.onXhrLoad, false );
		this.xhr.addEventListener( 'error', this.onXhrError, false );
		this.xhr.addEventListener( 'abort', this.onXhrAbort, false );

		const formData = new FormData();
		formData.append( 'action', this.action );
		formData.append( '_ajax_nonce', this.nonce );
		formData.append( 's', searchTerm );

		for ( const key in this.requestArgs )
		{
			formData.append( key, this.requestArgs[ key ] );
		}

		this.xhr.open( 'POST', this.ajaxUrl );
		this.xhr.send( formData );

		this.lastSearchTerm = searchTerm;

		if ( searchTerm )
		{
			window.dispatchEvent( new CustomEvent( 'wmuwpblocks/search/start', {
				detail: {
					block: this,
					searchTerm: searchTerm
				}
			} ) );
		}

		this.element.classList.add( 'search-in-progress' );
	}

	/**
	 * 
	 */
	close()
	{
		if ( false === this.isOpen ) return;

		this.isOpen = false;
		this.element.classList.remove( 'is-open' );

		document.removeEventListener( 'click', this.onClickOutside );
		this.overlayScrollClear();

		window.dispatchEvent( new CustomEvent( 'wmuwpblocks/search/close', {
			detail: {
				block: this,
			}
		} ) );
	}

	/**
	 * 
	 */
	open()
	{
		if ( true === this.isOpen ) return;

		this.isOpen = true;
		this.element.classList.add( 'is-open' );

		document.addEventListener( 'click', this.onClickOutside );
		this.overlayScrollSetup();

		window.dispatchEvent( new CustomEvent( 'wmuwpblocks/search/open', {
			detail: {
				block: this,
			}
		} ) );
	}

	/**
	 * 
	 */
	toggleOpen()
	{
		if ( this.isOpen )
		{
			this.close();
		}
		else
		{
			this.open();
		}
	}

	/**
	 * 
	 */
	overlayScrollClear()
	{
		if ( ! this.overlayScrollCustomBehavior )
		{
			const body = document.querySelector( 'body' );
			body.style.overflowY = null;
			return;
		}

		window.removeEventListener( 'scroll', this.onWindowScroll );
		this.overlayScrollEnabled = false;
		
		const body = document.querySelector( 'body' );
		body.style.height = null;
		this.scrollDummyElement.remove();

		document.querySelectorAll( 'body > *' ).forEach( ( element ) =>
		{
			if ( element.wmuSearchOverlayScrollSetup )
			{
				element.style.position = ( element.wmuInitStylePosition ) ? element.wmuInitStylePosition : null;
				element.wmuSearchOverlayScrollSetup = undefined;
			}
		} );

		if ( ! this.isOpen && this.overlayScrollSetupTimeoutId )
		{
			clearInterval( this.overlayScrollSetupTimeoutId );
			this.overlayScrollSetupTimeoutId = null;
		}

		if ( null !== this.overlayWindowScrollY )
		{
			window.scrollTo( { top: this.overlayWindowScrollY } );
			this.overlayWindowScrollY = null;
		}
	}

	/**
	 * 
	 */
	overlayScrollSetup()
	{
		if ( ! this.overlayScrollCustomBehavior )
		{
			const body = document.querySelector( 'body' );
			body.style.overflowY = 'hidden';
			return;
		}

		/**
		 * On clear systématiquement ?
		 */
		if ( this.overlayScrollEnabled )
		{
			this.overlayScrollClear();
		}

		/**
		 * On créé avec un décalage pour laisser l'application des éventuels activation de slider et autres
		 * 
		 * On peut peut-être utiliser cette fonction pour la surveillance en fait
		 */
		this.overlayScrollSetupTimeoutId = setInterval( this.overlayScrollSetupTimeout, 350 );
	}

	/**
	 * 
	 */
	overlayScrollSetupTimeout()
	{
		if ( null === this.overlayScrollSetupTimeoutId ) return;

		const rect = this.resultElement.getBoundingClientRect();
		const height = this.resultElement.offsetHeight + ( rect.top + this.overlayScrollElement.scrollTop );
		
		if ( height > window.innerHeight )
		{
			let body;
			const ignoreTagNames = [ 'script', 'noscript', 'template', 'link' ];

			if ( ! this.overlayScrollEnabled )
			{
				this.overlayScrollElement.scrollTop = 0;
				this.overlayWindowScrollY = window.scrollY;
				window.scrollTo( { top: 0 } );
				window.addEventListener( 'scroll', this.onWindowScroll );

				body = document.querySelector( 'body' );
				body.style.height = `${height}px`;

				if ( null === this.scrollDummyElement )
				{
					this.scrollDummyElement = document.createElement( 'div' );
					this.scrollDummyElement.classList.add( this.scrollDummyClassName );
					this.scrollDummyElement.style.position = 'absolute';
					this.scrollDummyElement.style.top = '0px';
					this.scrollDummyElement.style.width = '100%';
					this.scrollDummyElement.style.zIndex = '-1';
				}

				this.scrollDummyElement.style.height = `${height}px`;
				body.appendChild( this.scrollDummyElement );

				document.querySelectorAll( 'body > *' ).forEach( ( element ) =>
				{
					if ( -1 !== ignoreTagNames.indexOf( element.tagName.toLowerCase() ) ) return;

					if ( ! element.wmuSearchOverlayScrollSetup )
					{
						element.wmuInitStylePosition = element.style.position;
						element.style.position = 'fixed';
						element.wmuSearchOverlayScrollSetup = true;
					}
				} );

				this.overlayScrollEnabled = true;
			}
			else if ( this.overlayScrollLastHeight !== height )
			{
				body = document.querySelector( 'body' );
				body.style.height = `${height}px`;
				this.scrollDummyElement.style.height = `${height}px`;
			}
		}
		else if ( this.overlayScrollEnabled )
		{
			this.overlayScrollClear();
		}

		this.overlayScrollLastHeight = height;
	}

	/**
	 * 
	 * @param {Number} scrollTop 
	 */
	overlayScroll( scrollTop )
	{
		if ( this.overlayScrollEnabled && this.overlayScrollElement )
		{
			this.overlayScrollElement.scrollTop = scrollTop;
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onClickOutside( event )
	{
		if ( ! this.isOpen || ! this.closeOnClickOutside || this.element === event.target.closest( '.block-search' ) )
		{
			return;
		}

		this.close();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onCloseClick( event )
	{
		event.preventDefault();
		this.close();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onFocusIn( event )
	{
		this.element.classList.add( 'focus' );

		if ( this.lastSearchTerm && this.inputElement.value )
		{
			this.open();
		}
		else if ( this.searchOnFocus && ! this.inputElement.value )
		{
			this.searchStart( this.searchOnFocusTerm );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onFocusOut( event )
	{
		this.element.classList.remove( 'focus' );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onInput( event )
	{
		if ( null !== this.inputTimeoutId )
		{
			clearTimeout( this.inputTimeoutId );
		}

		setTimeout( this.onInputTimeout, this.inputTimeoutDelay );
	}
	
	/**
	 * 
	 */
	onInputTimeout()
	{
		this.open();
		this.searchStart();
		this.inputTimeoutId = null;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onSearchLinkClick( event )
	{
		event.preventDefault();

		const target = ( 'a' === event.target.tagName.toLowerCase() ) ? event.target : event.target.closest( 'a' );
		if ( ! target ) return;

		const searchTerm = target.href.substring( 7 );

		if ( searchTerm )
		{
			this.searchStart( searchTerm );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onToggleClick( event )
	{
		event.preventDefault();
		this.toggleOpen();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onWindowScroll( event )
	{
		this.overlayScroll( window.scrollY );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onXhrAbort( event )
	{
		// console.log( 'onXhrAbort', event );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onXhrError( event )
	{
		// console.log( 'onXhrError', event );
		this.searchError( event );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onXhrLoad( event )
	{
		let response = null;

		if ( this.xhr.response )
		{
			response = JSON.parse( this.xhr.response );
		}

		if ( response && true === response.success )
		{
			this.searchSuccess( response.data );
		}
		else
		{
			this.searchError( response );
		}
		
		this.searchComplete();
	}

}

export default BlockSearch;